import packageInfo from '../package.json'

const windowEnv = window._env_ || {}
const processEnv = process.env || {}

let allowedAppIds = windowEnv.REACT_APP_ALLOWED_APP_IDS || processEnv.REACT_APP_ALLOWED_APP_IDS
if (!!allowedAppIds && allowedAppIds.length > 0) allowedAppIds = allowedAppIds.split(',')
else allowedAppIds = undefined

const config = {
	version: packageInfo.version,
	nodeEnvironment: processEnv.NODE_ENV,
	tier: windowEnv.REACT_APP_TIER || processEnv.REACT_APP_TIER || 'local',

	// EventStore API
	apiDomain: windowEnv.REACT_APP_API_DOMAIN || processEnv.REACT_APP_API_DOMAIN || 'localhost:3001',

	// Term API
	termsApiEndpoint: windowEnv.REACT_APP_TERMS_API_ENDPOINT || processEnv.REACT_APP_TERMS_API_ENDPOINT || '',

	// Application Insights
	appInsightsConnectionString:
		windowEnv.REACT_APP_APPINSIGHTS_CONNECTION_STRING || processEnv.REACT_APP_APPINSIGHTS_CONNECTION_STRING || '',

	// Sentry Error Logging
	sentryDSN: windowEnv.REACT_APP_SENTRY_DSN || processEnv.REACT_APP_SENTRY_DSN || '',
	sentryTracesSampleRate:
		windowEnv.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || processEnv.REACT_APP_SENTRY_TRACES_SAMPLE_RATE
			? Number(windowEnv.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || processEnv.REACT_APP_SENTRY_TRACES_SAMPLE_RATE)
			: undefined,
	sentryReplaysSessionSampleRate:
		windowEnv.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ||
		processEnv.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE
			? Number(
					windowEnv.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ||
						processEnv.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE
			  )
			: undefined,
	sentryReplaysOnErrorSampleRate:
		windowEnv.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ||
		processEnv.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE
			? Number(
					windowEnv.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ||
						processEnv.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE
			  )
			: undefined,

	// Google Analytics
	googleAnalytics: windowEnv.REACT_APP_GOOGLE_ANALYTICS || processEnv.REACT_APP_GOOGLE_ANALYTICS || '',

	// OAuth
	clientId: 'scope',
	clientSecret: windowEnv.REACT_APP_OAUTH_CLIENT_SECRET || processEnv.REACT_APP_OAUTH_CLIENT_SECRET || 'SECRETKEY',

	// Whitelisted apps for display
	allowedAppIds
}

export default config
